import ErrorPage from '../../staticPages/components/ErrorPage';
import GeneralContentPage from '../../generalContent/components/GeneralContentPage';
import React from 'react';
import TaskListPage from './TaskListPage';
import withTaskFlow from './WithTaskFlow';
import { AssessmentPage, ScoreEvaluationPage } from '../../assessment/components';
import { useLocation } from 'react-router-dom';
import { routeMappings } from '../../constants';
import { RoutePageProps, RouteParams } from '../../base/components/Routes';
import { withBasicDetails } from '../../base/components/WithBasicDetails';

const EndPage = React.lazy(() => import('./EndPage'));
const HurdleFailPage = React.lazy(() => import('./HurdleFailPage'));
const QuizFeedbackPage = React.lazy(() => import('../../candidateFeedback/components/quizFeedback/QuizFeedbackPage'));
const VideoTaskModalPage = React.lazy(() => import('../../videoTask/components/VideoTaskModalPage'));
const ManualHurdlePage = React.lazy(() => import('./ManualHurdlePage'));

export const taskRoutes: RouteParams[] = [
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['GENCONTENT']}/:itemId`,
    exact: true,
    component: withBasicDetails(withTaskFlow(GeneralContentPage)),
  },
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['EXPASSES']}/:itemId`,
    exact: true,
    component: withBasicDetails(withTaskFlow(AssessmentPage)),
  },
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['EXPQUIZ']}/:itemId`,
    exact: true,
    component: withBasicDetails(withTaskFlow(AssessmentPage)),
  },
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['EXPASSES']}/:itemId${routeMappings['ASSESSMENT_EVALUATION']}`,
    exact: true,
    component: withBasicDetails(withTaskFlow(ScoreEvaluationPage)),
  },
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['EXPQUIZ']}/:itemId${routeMappings['QUIZ_FEEDBACK']}`,
    exact: true,
    component: withBasicDetails(withTaskFlow(QuizFeedbackPage)),
  },
  {
    path: `${routeMappings['TASK']}/*`,
    exact: true,
    component: ErrorPage,
  },
];

const taskListRoutes: RouteParams[] = [
  {
    path: `${routeMappings['TASKLIST']}/:id`,
    exact: true,
    component: withBasicDetails(TaskListPage),
    customProps: {
      pageName: 'taskListTitle',
    },
  },
  {
    path: routeMappings['TASKLIST_END'],
    exact: true,
    component: withBasicDetails(withTaskFlow(EndPage)),
    customProps: {
      pageName: 'endPageTitle',
    },
  },
  {
    path: routeMappings['TASKLIST_HURDLE_FAIL'],
    exact: true,
    component: withBasicDetails(withTaskFlow(HurdleFailPage)),
    customProps: {
      pageName: 'hurdle',
    },
  },
  {
    path: routeMappings['TASKLIST_MANUAL_HURDLE'],
    exact: true,
    component: withBasicDetails(withTaskFlow(ManualHurdlePage)),
    customProps: {
      pageName: 'stageCompletionTitle',
    },
  },
];

const VideoTaskComponentComp = (props: RoutePageProps): React.JSX.Element => {
  const VideoTaskComponent: (props: RoutePageProps) => JSX.Element = withBasicDetails(withTaskFlow(VideoTaskModalPage));
  return <VideoTaskComponent {...props} />;
};

const VideoTask = (): React.JSX.Element => {
  const location = useLocation();
  const backgroundComponent = location.state?.background;
  return <>{backgroundComponent && <VideoTaskComponentComp />}</>;
};

taskListRoutes.push({
  path: `${routeMappings['TASK']}/:id${routeMappings['EXPVIDEOTASK']}/:itemId`,
  exact: true,
  component: VideoTask,
});

export default taskListRoutes;
